import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
window.gsap = gsap;
gsap.registerPlugin(ScrollToPlugin);

// form vars
const contactForm = document.querySelector('#enquiry-form');
const contactFormWrap = document.querySelector('#enquiry-form-wrapper');
// ajax loader
let loader = document.createElement('div');
loader.className = 'lds-ripple';
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
// form submit
contactForm.addEventListener('submit', (event) => {
	event.preventDefault();
	let formData = new FormData(contactForm);
	contactForm.classList.add('ajaxing');
	contactForm.append(loader);
	if (contactForm.classList.contains('customer-form')) {
		formData.append('action', 'customer_form');
	} else {
		formData.append('action', 'enquiry_form');
	}
	// form ajax
	axios
		.post(ajaxurl, formData)
		.then((response) => {
			// console.log(response);
			// remove ajax and loader
			contactForm.classList.remove('ajaxing');
			loader.remove();
			// form response and status vars
			let formMessage = contactFormWrap.querySelector('.form-response');
			formMessage.innerHTML = '';
			let formStatus;
			if (response.data !== '' && response.data.constructor === Object) {
				formStatus = response.data.status;
			} else {
				formStatus = response.data;
			}
			// get response message based on status
			let responseMessage = contactFormWrap.querySelector('.template-' + formStatus).content.cloneNode(true);
			if (formStatus == 'success') {
				contactFormWrap.innerHTML = '';
				contactFormWrap.append(responseMessage);
				contactFormWrap.classList.add('enquiry-form-success');
				// send GA conversion
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'formSubmission',
					formType: 'Customer Form',
				});
			} else {
				formMessage.append(responseMessage);
				formMessage.classList.add('form-response--' + formStatus);
				response.data.errors.forEach((error) => {
					let list = document.createElement('li');
					list.textContent = error;
					contactFormWrap.querySelector('#enquiry-form-errors').append(list);
				});
			}
			// scroll response into view
			gsap.to(window, { delay: 0.2, duration: 0.7, scrollTo: { y: '.contact-hero__content', offsetY: 100 }, ease: 'sine.out' });
		})
		.catch((error) => {
			console.log(error);
			contactForm.classList.remove('ajaxing');
			loader.remove();
		});
});
